// Type that excludes functions - used to distinguish values from provider functions.
type NotFunction = object | string | number | boolean | bigint | null | undefined | symbol;

export type ValueOrProvider<T extends NotFunction> = T | (() => T);

export const resolveValueOrProvider = <T extends NotFunction>(valueProvider: ValueOrProvider<T>): T => {
	if (typeof valueProvider === "function") {
		return valueProvider();
	} else {
		return valueProvider;
	}
};
